<div [ngClass]="boxCssClass" class="blog-box-container">
  <h4 class="mb-2 text-xl font-bold">Kategorier</h4>
  <ul class="blog-box-list">
    <li
      *ngFor="let item of filteredTags; trackBy: trackByMethod"
      class="blog-box-list-item"
    >
      <a [routerLink]="item.routerLink" title="{{ item.name }}">{{item.anchor}}</a>
    </li>
  </ul>
  <div *ngIf="showExpand" class="blog-box-toggle-container">
    <app-ui-button
      (onClick)="toggleExpand()"
      [color]="'outline-tertiary'"
      [compressed]="false"
      [expanded]="'inline'"
      [size]="'md'"
    >
      {{ buttonLabel }}
    </app-ui-button>
  </div>
</div>
